import { LinearProgress, Box, Typography } from "@mui/material";
import { useState, useEffect, useRef } from "react";

export default function LoadingMainPage({ isLoading, widthProp = "50%" }) {
  const [progress, setProgress] = useState(0);
  const [buffer, setBuffer] = useState(10);

  const progressRef = useRef(() => {});
  useEffect(() => {
    progressRef.current = () => {
      if (progress === 100) {
        setProgress(0);
        setBuffer(10);
      } else {
        setProgress(progress + 1);
        if (buffer < 100 && progress % 5 === 0) {
          const newBuffer = buffer + 1 + Math.random() * 10;
          setBuffer(newBuffer > 100 ? 100 : newBuffer);
        }
      }
    };
  });

  useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, 100);

    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Box
      sx={{
        width: "60%",
        maxWidth: 500,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        bgcolor: "background.paper",
        boxShadow: 6,
        borderRadius: "4px",
        p: 4,
        textAlign: "center",
      }}>
      <Typography
        variant="h4"
        component="h1"
        gutterBottom
        sx={{ color: "primary.main", marginBottom: "20px" }}>
        Cargando....
      </Typography>

      <LinearProgress
        variant="buffer"
        value={progress}
        valueBuffer={buffer}
        sx={{ height: 14, borderRadius: "4px" }}
      />
    </Box>
  );
}
